/* Lumetier wordmark — text-based (no image asset).
   Letter-spaced serif "LUMETIER" matching the marketing site treatment.

   Variants:
     - tone="light"  (default) → light-on-dark (for the dark sidebar / login)
     - tone="dark"           → dark-on-light (in case it's ever needed)

   The wordmark renders at the font-size set by the parent; tweak with the
   `className` prop (e.g. `text-base`, `text-lg`). The gap between letters
   is the signature treatment, so we set it inline here (not via Tailwind
   arbitrary value) to make it foolproof. */
export default function LumetierWordmark({
  className = "",
  tone = "light",
  testid = "lumetier-wordmark",
  href, // optional — when set, renders as a link to that path
  as: As = "span",
}) {
  const color = tone === "dark" ? "text-stone-900" : "text-stone-100";
  return (
    <As
      data-testid={testid}
      className={`font-serif font-light ${color} select-none ${className}`}
      style={{ letterSpacing: "0.32em" }}
      aria-label="Lumetier"
    >
      LUMETIER
    </As>
  );
}
